module.exports = __webpack_public_path__ + "static/media/UserFriendly.218a44e0.svg";